import Footer from './Footer'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  categories: state.categories.categories,
  locale: state.router.locale,
})

export default connect(mapStateToProps)(Footer)
